module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/en-顶部图.0d0263be.png";